import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const accountsReducer = createAsyncReducer({
    name: 'accounts',
    initialState: {
        currentAccount: null,
        currentAccountLoading: false,
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        loadCurrentAccount: create.asyncThunk(
            async () => {
                return await Fetch.get(Routes.ajax_accounts_session_account_path());
            },
            {
                pending: (state, action) => {
                    state.currentAccountLoading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.currentAccountLoading = false;
                    state.currentAccount = action.payload;
                    if (action.payload) {
                        state.records[action.payload.id] = action.payload;
                    }
                },
                rejected: (state, action) => {
                    const { message } = action.error;
                    state.errorMessage = message;
                    state.currentAccountLoading = false;
                }
            }
        )
    })
});

export default accountsReducer;